import momemt from 'moment';

export default function Events() {
	$.ajax({
		url: 'https://rest.bandsintown.com/artists/Russell%20Dickerson/events?app_id=45PRESS_RUSSEL_DICKERSON',
		method: 'GET',
		dataType: 'json',
		error: (res) => {
			console.log(res);
			alert( 'Error fetching events!' );
		},
		success: data => {
			const events = $( '.tour-list' );
			let html = '';
			let count = 0;
			if ( data.length ) {
				for ( let event of data ) {
					if (count >= 5) break;
					const location = event.venue.city + ', ' + event.venue.region;
					html += '<div class="event">';
					html += '<div class="event-date">' + momemt( event.datetime ).format( 'MMM D, YY' ) + '</div>';
					html += '<div class="event-detail">' + event.venue.name + ' | ' + location + '</div>';
					html += '<div class="event-links">';
					for ( let offer of event.offers ) {
						html += '<a href="' + offer.url + '" target="_blank" class="btn btn-border">' + offer.type + '</a>';
					}
					html += '</div>';
					html += '</div>';
					count++;
				}
				events.html( html );
			} else {
				events.html( 'No upcoming events.' );
			}
		}
	});

	$.ajax({
		url: 'https://rest.bandsintown.com/artists/Russell%20Dickerson/events?app_id=45PRESS_RUSSEL_DICKERSON',
		method: 'GET',
		dataType: 'json',
		error: (res) => {
			console.log(res);
			alert( 'Error fetching events!' );
		},
		success: data => {
			const events = $( '.tours' );
			let html = '';
			let count = 0;
			if ( data.length ) {
				for ( let event of data ) {
					const location = event.venue.city + ', ' + event.venue.region;
					html += '<div class="event">';
					html += '<div class="event-info">';
					html += '<div class="event-date">' + momemt( event.datetime ).format( 'MMM D, YY' ) + '</div>';
					html += '<div class="event-name">' + event.venue.name + '</div>';
					html += '<div class="event-location">' + location + '</div>';
					html += '</div>';
					html += '<div class="event-links">';
					for ( let offer of event.offers ) {
						html += '<a href="' + offer.url + '" target="_blank" class="btn btn-border">' + offer.type + '</a>';
					}
					html += '</div>';
					html += '</div>';
					count++;
				}
				events.html( html );
			} else {
				events.html( 'No upcoming events.' );
			}
		}
	});
}